import { KYMW0400Component } from './kymw0400.component';

/**
 * 取引先一覧画面の値を管理するクラス
 *
 * @export KYMW0400Model
 * @class KYMW0400Model
 */
export class KYMW0400Model {

  kymw0400Component: KYMW0400Component;

  /**
   * 検索カナ行
   *
   * @type {string}
   * @memberof KYMW0400Model
   */
  public searchKana: string = null;

  /**
   * 選択タブインデックス
   *
   * @type {number}
   * @memberof KYMW0400Model
   */
  public index: number = null;

  /**
   * 取引先一覧
   *
   * @type {Array<any>}
   * @memberof KYMW0400Model
   */
  public supplierList: Array<any> = new Array<any>();

  /**
   * 呼出元区分(0：発注先取引先、1：支払先取引先)
   *
   * @type {string}
   * @memberof KYMW0400Model
   */
  public supplierFlg: string = null;

  /**
   * 複数選択モード(true: チェックボックス表示)
   * @type {boolean}
   * @memberof KYMW0400Model
   */
  public isMultiCheckable: boolean;
}
